function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.5,20 C2.916,20 0,17.084 0,13.5 L0,4 C0,3.447 0.448,3 1,3 C1.552,3 2,3.447 2,4 L2,13.5 C2,15.981 4.019,18 6.5,18 C8.981,18 11,15.981 11,13.5 L11,4 C11,2.897 10.103,2 9,2 C7.897,2 7,2.897 7,4 L7,13 C7,13.553 6.552,14 6,14 C5.448,14 5,13.553 5,13 L5,4 C5,1.794 6.794,0 9,0 C11.206,0 13,1.794 13,4 L13,13.5 C13,17.084 10.084,20 6.5,20",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-3 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/attachement.57b41bd8.svg";
export { SvgComponent as ReactComponent };